(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casecorex-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.cx-menu-button');if(!button)return;const nav=document.getElementById(button.getAttribute('aria-controls'));const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));nav.hidden=open;});
document.addEventListener('click',function(event){document.querySelectorAll('[data-language-menu][open]').forEach(function(menu){if(!menu.contains(event.target))menu.removeAttribute('open');});});
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('[data-language-menu][open]').forEach(function(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casecorex-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(cents){const currency=window.Shopify?.currency?.active||'USD';return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(cents/100);}
  function init(root){
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    let index=0,quickProduct=null;
    const media=[...root.querySelectorAll('[data-media-index]')],thumbs=[...root.querySelectorAll('[data-thumb-index]')];
    const dialog=root.querySelector('[data-quick-dialog]'),quickOptions=root.querySelector('[data-quick-options]'),quickSubmit=root.querySelector('[data-quick-submit]'),quickStatus=root.querySelector('[data-quick-status]');
    async function addItemsAndOpenDrawer(items,trigger){
      const cartDrawer=document.querySelector('cart-drawer');
      const cartNotification=document.querySelector('cart-notification');
      const target=cartDrawer||cartNotification;
      const payload={items:items};
      if(target&&typeof target.getSectionsToRender==='function'){
        payload.sections=target.getSectionsToRender().map(section=>section.section||section.id);
        payload.sections_url=window.location.pathname;
      }
      const response=await fetch((window.routes&&routes.cart_add_url)||'/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(payload)
      });
      const data=await response.json();
      if(!response.ok||data.status)throw new Error(data.description||'Unable to add item');
      if(target&&typeof target.renderContents==='function'){
        if(typeof target.setActiveElement==='function'&&trigger)target.setActiveElement(trigger);
        target.renderContents(data);
        if(typeof target.open==='function')setTimeout(()=>target.open(trigger),60);
      }else{
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:data}}));
      }
      return data;
    }
    function show(i){if(!media.length)return;index=(i+media.length)%media.length;media.forEach((el,n)=>el.hidden=n!==index);thumbs.forEach((el,n)=>el.classList.toggle('is-active',n===index));}
    function showMediaById(mediaId){
      if(!mediaId)return false;
      const mediaIndex=media.findIndex(el=>el.dataset.mediaId===String(mediaId));
      if(mediaIndex<0)return false;
      show(mediaIndex);return true;
    }
    function selectedQuickVariant(){if(!quickProduct)return null;const values=[...quickOptions.querySelectorAll('select')].map(s=>s.value);return quickProduct.variants.find(v=>v.options.every((value,i)=>value===values[i]));}
    function updateQuick(){
      const variant=selectedQuickVariant();
      const image=root.querySelector('[data-quick-image]');
      const source=variant?.featured_image?.src||quickProduct?.featured_image;
      if(source){image.src=source;image.alt=quickProduct.title+' — '+(variant?.title||'');}
      root.querySelector('[data-quick-price]').textContent=variant?money(variant.price):'';
      quickSubmit.disabled=!variant||!variant.available;
      quickSubmit.textContent=!variant?root.dataset.chooseText:variant.available?root.dataset.addText+' · '+money(variant.price):root.dataset.soldOutText;
    }
    async function openQuick(button){
      quickStatus.textContent='Loading options…';quickSubmit.disabled=true;dialog.showModal();
      root.querySelector('[data-quick-title]').textContent=button.dataset.title;
      root.querySelector('[data-quick-image]').src=button.dataset.image;
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'products/'+button.dataset.handle+'.js');
        if(!response.ok)throw new Error('Product unavailable');
        quickProduct=await response.json();quickOptions.innerHTML='';
        quickProduct.options.forEach((option,i)=>{
          const wrap=document.createElement('div');wrap.className='pxp__quick-option';
          const label=document.createElement('label');label.textContent=option.name;
          const select=document.createElement('select');select.setAttribute('aria-label',option.name);
          option.values.forEach(value=>{const item=document.createElement('option');item.value=value;item.textContent=value;select.appendChild(item);});
          select.addEventListener('change',updateQuick);wrap.append(label,select);quickOptions.appendChild(wrap);
        });
        quickStatus.textContent='';updateQuick();
      }catch(error){quickStatus.textContent='Options could not be loaded. Please try again.';}
    }
    root.addEventListener('click',function(e){
      const thumb=e.target.closest('[data-thumb-index]');if(thumb)show(Number(thumb.dataset.thumbIndex));
      if(e.target.closest('.pxp__gallery-arrow--prev'))show(index-1);
      if(e.target.closest('.pxp__gallery-arrow--next'))show(index+1);
      const qty=root.querySelector('.pxp__qty input');
      if(e.target.closest('[data-qty-minus]'))qty.value=Math.max(1,Number(qty.value||1)-1);
      if(e.target.closest('[data-qty-plus]'))qty.value=Number(qty.value||1)+1;
      if(e.target.closest('[data-sticky-add]'))root.querySelector('.pxp__add').click();
      const quick=e.target.closest('[data-quick-add]');if(quick)openQuick(quick);
      if(e.target.closest('[data-quick-close]'))dialog.close();
    });
    quickSubmit.addEventListener('click',async function(){
      const variant=selectedQuickVariant();if(!variant||!variant.available)return;
      quickSubmit.disabled=true;quickStatus.textContent='Adding to your bag…';
      try{
        await addItemsAndOpenDrawer([{id:variant.id,quantity:1}],quickSubmit);
        quickStatus.textContent='Added to your bag ✓';quickSubmit.textContent='ADDED ✓';
        dialog.close();
      }catch(error){quickStatus.textContent=error.message||'Could not add this option. Please try again.';quickSubmit.disabled=false;}
    });
    const radios=[...root.querySelectorAll('[data-option-value]')],select=root.querySelector('.pxp__variant-select'),bundleRadios=[...root.querySelectorAll('[data-bundle-quantity]')],quantityInput=root.querySelector('.pxp__qty input'),productForm=root.querySelector('.pxp__form'),addButton=root.querySelector('.pxp__add');
    productForm?.addEventListener('submit',async function(event){
      event.preventDefault();
      if(!select||!select.value||addButton.disabled)return;
      const label=root.querySelector('[data-add-label]'),originalLabel=label.textContent;
      addButton.disabled=true;label.textContent='ADDING…';
      try{
        await addItemsAndOpenDrawer([{id:Number(select.value),quantity:Math.max(1,Number(quantityInput.value||1))}],addButton);
        label.textContent='ADDED ✓';
        setTimeout(()=>{label.textContent=originalLabel;addButton.disabled=false;},1000);
      }catch(error){
        label.textContent=error.message||'TRY AGAIN';
        setTimeout(()=>{label.textContent=originalLabel;addButton.disabled=false;},1800);
      }
    });
    function updateBundlePrices(priceCents){
      root.querySelectorAll('[data-bundle-total]').forEach(el=>{el.textContent=money(priceCents*Number(el.dataset.payQuantity));});
      root.querySelectorAll('[data-bundle-saving]').forEach(el=>{el.textContent=money(priceCents*Number(el.dataset.freeQuantity));});
      const selectedBundle=root.querySelector('[data-bundle-quantity]:checked');
      if(selectedBundle){
        quantityInput.value=selectedBundle.dataset.bundleQuantity;
        root.querySelector('[data-add-price]').textContent=money(priceCents*Number(selectedBundle.dataset.payQuantity));
        root.querySelector('[data-mobile-price]').textContent=money(priceCents*Number(selectedBundle.dataset.payQuantity));
      }
    }
    function updateVariant(event){
      if(!select)return;
      const selected=[...root.querySelectorAll('.pxp__form fieldset[data-option-position]')].map(fs=>fs.querySelector('input:checked')?.value||'');
      const match=[...select.options].find(o=>selected.every((v,i)=>!v||o.dataset['option'+(i+1)]===v));if(!match){select.value='';addButton.disabled=true;root.querySelector('[data-add-label]').textContent=root.dataset.unavailableText;return;}
      select.value=match.value;const available=match.dataset.available==='true';
      root.querySelector('[data-product-price]').textContent=match.dataset.price;updateBundlePrices(Number(match.dataset.priceCents));
      const compare=root.querySelector('[data-compare-price]');compare.textContent=match.dataset.compare;compare.hidden=!match.dataset.compare||Number(match.dataset.compareCents)<=Number(match.dataset.priceCents);
      const add=root.querySelector('.pxp__add');add.disabled=!available;root.querySelector('[data-add-label]').textContent=available?root.dataset.addText:root.dataset.soldOutText;
      showMediaById(match.dataset.mediaId||event?.target?.dataset.mediaId);
      history.replaceState({},'',location.pathname+'?variant='+match.value);
      root.querySelectorAll('.pxp__form fieldset[data-option-position]').forEach(fs=>{const checked=fs.querySelector('input:checked');if(checked)fs.querySelector('[data-selected-option]').textContent=checked.value;});
    }
    radios.forEach(r=>r.addEventListener('change',updateVariant));
    bundleRadios.forEach(r=>r.addEventListener('change',function(){updateBundlePrices(Number(select.selectedOptions[0].dataset.priceCents));}));
    const reviewTrack=root.querySelector('.jdgm-ssr-reviews__list');
    if(reviewTrack){
      const reviewCards=[...reviewTrack.querySelectorAll('.jdgm-rev')];
      let reviewIndex=0,reviewTimer;
      function showReview(next){
        if(!reviewCards.length)return;
        reviewIndex=(next+reviewCards.length)%reviewCards.length;
        reviewTrack.scrollTo({left:reviewCards[reviewIndex].offsetLeft-reviewTrack.offsetLeft,behavior:'smooth'});
      }
      function restartReviews(){clearInterval(reviewTimer);if(reviewCards.length>1)reviewTimer=setInterval(()=>showReview(reviewIndex+1),5500);}
      root.querySelector('[data-review-prev]')?.addEventListener('click',()=>{showReview(reviewIndex-1);restartReviews();});
      root.querySelector('[data-review-next]')?.addEventListener('click',()=>{showReview(reviewIndex+1);restartReviews();});
      reviewTrack.addEventListener('pointerdown',()=>clearInterval(reviewTimer));
      reviewTrack.addEventListener('pointerup',restartReviews);
      restartReviews();
    }
    updateBundlePrices(Number(select?.selectedOptions?.[0]?.dataset.priceCents||0));
    if(!showMediaById(select?.selectedOptions?.[0]?.dataset.mediaId))show(0);
  }
  document.querySelectorAll('.pxp').forEach(init);
  document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.pxp')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tongue-care-cart"]) return;
  try {
    
(()=>{let initialized=false;
const init=()=>{const d=document.querySelector('[data-tg-cart-dialog]');if(!d||initialized)return;initialized=true;const cfg=JSON.parse(d.querySelector('[data-cart-config]').textContent);const items=d.querySelector('[data-cart-items]');const error=d.querySelector('[data-drawer-error]');let previous;
const make=(tag,text,cls)=>{const el=document.createElement(tag);if(text!=null)el.textContent=text;if(cls)el.className=cls;return el;};
const load=async()=>{error.textContent='';const response=await fetch(cfg.url,{headers:{Accept:'application/json'}});if(!response.ok)throw new Error(cfg.error);const cart=await response.json();const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart.currency||'USD'}).format(cents/100);items.replaceChildren();if(!cart.items.length)items.append(make('p',cfg.empty));
for(const item of cart.items){const row=make('div',null,'tg-cart-line');if(item.image){const img=make('img');img.src=item.image;img.alt=item.product_title;row.append(img);}const info=make('div',null,'tg-cart-line-info');info.append(make('strong',item.product_title));if(item.variant_title)info.append(make('p',item.variant_title));if(item.selling_plan_allocation)info.append(make('p',item.selling_plan_allocation.selling_plan.name));info.append(make('p',item.quantity+' × '+money(item.final_price)));const remove=make('button',cfg.remove,'tg-cart-remove');remove.type='button';remove.addEventListener('click',async()=>{remove.disabled=true;try{const res=await fetch(cfg.change,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity:0})});if(!res.ok)throw new Error(cfg.error);await load();}catch(e){error.textContent=cfg.error;remove.disabled=false;}});info.append(remove);row.append(info);items.append(row);}d.querySelector('[data-cart-total]').textContent=money(cart.total_price);d.querySelector('[name="checkout"]').disabled=!cart.item_count;document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);};
const open=async()=>{previous=document.activeElement;if(!d.open)d.showModal();try{await load();}catch(e){error.textContent=cfg.error;}};
d.querySelector('[data-cart-close]').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d){const box=d.getBoundingClientRect();if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)d.close();}});d.addEventListener('close',()=>previous?.focus());document.addEventListener('tongue:cart-added',open);document.addEventListener('click',e=>{const link=e.target.closest('[data-open-tg-cart]');if(link){e.preventDefault();open();}});};document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',()=>{initialized=false;init();});init();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tongue-care-product"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(!document.documentElement.dataset.tongueFaq){document.documentElement.dataset.tongueFaq='1';document.addEventListener('click',e=>{const b=e.target.closest('.lovilds-faq-question');if(!b)return;const item=b.closest('.lovilds-faq-item');const open=item.classList.toggle('active');b.setAttribute('aria-expanded',String(open));});}
 const init=(root)=>{
 if(root.dataset.ready)return;root.dataset.ready='1';
 const cfgNode=root.querySelector('[data-config]');if(!cfgNode)return;
 const cfg=JSON.parse(cfgNode.textContent);const form=root.querySelector('form');const feature=root.querySelector('.tg-featured');

 let busy=false;
 const quantity=form.querySelector('[name="quantity"]');
 root.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{quantity.stepDown();quantity.dispatchEvent(new Event('change',{bubbles:true}));});
 root.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{quantity.stepUp();quantity.dispatchEvent(new Event('change',{bubbles:true}));});
 const sticky=root.querySelector('[data-sticky]');const buy=root.querySelector('.tg-buy');
 if(sticky&&buy)new IntersectionObserver(entries=>{sticky.classList.toggle('is-visible',!entries[0].isIntersecting&&buy.getBoundingClientRect().bottom<0);}).observe(buy);
 form.addEventListener('submit',async e=>{
 if(e.submitter&&!e.submitter.matches('[data-submit]'))return;e.preventDefault();if(busy)return;busy=true;
 const buttons=[...root.querySelectorAll('[data-submit],[data-sticky-submit]')];buttons.forEach(b=>{b.disabled=true;b.textContent=cfg.adding;});
 const err=root.querySelector('[data-cart-error]');if(err)err.textContent='';
 try{const res=await fetch(cfg.cart_add,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const result=await res.json();if(!res.ok)throw new Error(result.description||cfg.error);document.dispatchEvent(new CustomEvent('tongue:cart-added'));if(!document.querySelector('[data-tg-cart-dialog]'))location.assign(form.action.replace('/add',''));}
 catch(error){if(err)err.textContent=error.message||cfg.error;}finally{busy=false;sync();}
 });

 const sync=()=>{const selected=root.querySelector('input[name="id"]:checked');if(!selected)return;
 const plan=root.querySelector('[data-plan]');const sub=root.querySelector('[data-subscription]');
 if(sub?.checked&&!(cfg.offers[selected.value]||[]).some(o=>String(o.id)===plan.value)){sub.checked=false;plan.disabled=true;plan.selectedIndex=0;}
 if(cfg.requires_plan&&sub){sub.checked=true;sub.disabled=true;plan.disabled=false;if(!plan.value)plan.selectedIndex=1;}
 const offer=sub?.checked?(cfg.offers[selected.value]||[]).find(o=>String(o.id)===plan.value):null;
 const badge=root.querySelector('[data-plan-discount]');if(badge){badge.hidden=!offer?.percent;badge.textContent=offer?cfg.save_label.replace('VALUE',offer.percent):'';}
 root.querySelectorAll('[data-price]:not(input)').forEach(el=>el.textContent=offer?.price||selected.dataset.price);
 root.querySelectorAll('.tg-option').forEach(row=>{const radio=row.querySelector('input');const a=sub?.checked?(cfg.offers[radio.value]||[]).find(o=>String(o.id)===plan.value):null;row.querySelector('[data-row-price]').textContent=a?.price||radio.dataset.price;const c=row.querySelector('[data-row-compare]');c.textContent=a?.compare||radio.dataset.compare;c.hidden=!c.textContent;});
 const compare=root.querySelector('[data-compare]:not(input)');compare.textContent=offer?.compare||selected.dataset.compare;compare.hidden=!compare.textContent;
 root.querySelectorAll('[data-submit],[data-sticky-submit]').forEach(b=>{b.disabled=selected.dataset.available!=='true';b.textContent=b.disabled?cfg.sold:cfg.add;});
 const stickySelect=root.querySelector('[data-sticky-variant]');if(stickySelect)stickySelect.value=selected.value;
 const qty=form.querySelector('[name="quantity"]');const rule=cfg.rules[selected.value]||{};qty.min=rule.min||1;qty.step=rule.increment||1;if(rule.max)qty.max=rule.max;else qty.removeAttribute('max');qty.value=Math.max(Number(qty.value)||1,Number(qty.min));
 if(selected.dataset.image&&feature){feature.src=selected.dataset.image;feature.removeAttribute('srcset');}
 const url=new URL(location.href);url.searchParams.set('variant',selected.value);if(offer)url.searchParams.set('selling_plan',offer.id);else url.searchParams.delete('selling_plan');history.replaceState({},'',url);
 };
 root.addEventListener('change',e=>{if(e.target.matches('[data-subscription]')){const plan=root.querySelector('[data-plan]');plan.disabled=!e.target.checked;if(e.target.checked&&!plan.value)plan.selectedIndex=1;if(!e.target.checked)plan.selectedIndex=0;}if(e.target.matches('input[name="id"],[data-subscription],[data-plan]'))sync();});
 const thumbs=[...root.querySelectorAll('.tg-thumb')];let galleryIndex=0;const showImage=i=>{if(!thumbs.length||!feature)return;galleryIndex=(i+thumbs.length)%thumbs.length;feature.src=thumbs[galleryIndex].dataset.src;feature.removeAttribute('srcset');feature.alt=thumbs[galleryIndex].getAttribute('aria-label');thumbs.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===galleryIndex)));root.querySelector('[data-gallery-count]').textContent=(galleryIndex+1)+' / '+thumbs.length;};thumbs.forEach((b,i)=>{b.setAttribute('aria-pressed',String(i===0));b.addEventListener('click',()=>showImage(i));});root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>showImage(galleryIndex-1));root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>showImage(galleryIndex+1));
 root.querySelector('[data-sticky-variant]')?.addEventListener('change',e=>{const r=[...root.querySelectorAll('input[name="id"]')].find(r=>r.value===e.target.value);if(r){r.checked=true;sync();}});
 root.querySelector('[data-sticky-submit]')?.addEventListener('click',()=>form.requestSubmit(root.querySelector('[data-submit]')));

 const selected=root.querySelector('input[name="id"]:checked');if(selected)root.querySelectorAll('[data-sticky-submit]').forEach(b=>b.disabled=selected.dataset.available!=='true');
 sync();};document.querySelectorAll('[data-tongue-root]').forEach(init);document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('[data-tongue-root]').forEach(init);});
})();

  } catch(e) { console.error(e); }
})();
})();
